import React from 'react';

export default function DownloadFiles() {
  return (
    <div style={{ maxWidth: 700, margin: '60px auto', padding: '0 20px', textAlign: 'center' }}>
      <h1>Download Files</h1>
      <p>Your downloads will appear here once an order is complete.</p>
    </div>
  );
}
